var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label"},[_vm._t("default"),(_vm.$props.required)?_c('span',{staticClass:"required-star"},[_vm._v("*")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }